import { DefaultEntityAdapter } from './default-entity.adapter';
import { NodeAdapter } from './interfaces/node.adapter';

export class DefaultNodeAdapter<T>
  extends DefaultEntityAdapter<T>
  implements NodeAdapter<T>
{
  constructor(
    idField = 'id',
    labelField = 'label',
    iconField = 'icon',
    protected readonly childrenField = 'children',
  ) {
    super(idField, labelField, iconField);
  }

  public getChildren(item: T): T[] {
    return (item[this.childrenField] as T[] | undefined) ?? [];
  }
}
